import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStage: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconStage"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4H22V20H2V4ZM20.4393 18.5L17.4349 15.5H6.56066L3.56066 18.5H20.4393Z" fill="currentColor"/></CentralIconBase>;
});

export default IconStage;
